import React, {useMemo} from "react";
import {Row, Col, Descriptions} from 'antd'
import { beiAnLink } from '@common/config'
import Link from '@components/Link'
import useCommon from '@common/context'
import './footer-container.scss'

const FooterContainer = () => {
    const { contactInfo } = useCommon()

    /** 移动端展示内容 */
    const mobileFooterInfo = useMemo(() => [
        {
            key: 'icp_license',
            label: '工业信息产业部备案号',
            children: <Link href={beiAnLink}>{contactInfo?.icp_license}</Link>,
        },
        {
            key: 'user_name',
            label: '联系人',
            children: <span>{contactInfo?.user_name}</span>,
        },
        {
            key: 'phone',
            label: '手机',
            children: <Link href={`tel:${contactInfo?.phone}`}>{contactInfo?.phone}</Link>,
        },
        {
            key: 'email',
            label: '邮箱',
            children: <Link href={`mailto:${contactInfo?.email}`}>{contactInfo?.email}</Link>,
        },
        {
            key: 'addr',
            label: '地址',
            children: contactInfo?.addr,
        },
        {
            key: 'post_code',
            label: '邮编',
            children: contactInfo?.post_code,
        }
    ], [contactInfo])

    return (
        <div className="footer-container">
            <Row>
                <Col xs={0} sm={0} md={24} xl={24}>
                    <div className="footer-copyright">
                        <span className="footer-company-name">Copyright © {contactInfo?.copyright} 版权所有</span>
                        <span>工业信息产业部备案号：<Link href={beiAnLink} style={{ color: '#609ee9' }}>{contactInfo?.icp_license}</Link></span>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={0} xl={0} className="footer-container-mobile">
                    <div className="copy-right">Copyright © {contactInfo?.copyright}</div>
                    <Descriptions items={mobileFooterInfo} size="small" className="desc-info" />
                </Col>
            </Row>
        </div>
    )
}

export default FooterContainer;